export default {
  AUTO_CAD: {
    name: 'AUTO_CAD',
    displayName: 'AutoCADおよび互換ソフト(******.dwg)',
    children: {
      '0': {displayName: '2016以前', name: 0, version: 0},
      '2016': {displayName: 2016, name: 2016, version: 1},
      '2017': {displayName: 2017, name: 2017, version: 2},
      '2018': {displayName: 2018, name: 2018, version: 3},
      '2019': {displayName: 2019, name: 2019, version: 4},
      '2020': {displayName: 2020, name: 2020, version: 5},
      '2021': {displayName: 2021, name: 2021, version: 6},
    }
  },

  REVIT: {
    name: 'REVIT',
    displayName: 'Revit(******.rvt)',
    children: {
      '2019': {displayName: 2019, name: 2019, version: 1},
      '2020': {displayName: 2020, name: 2020, version: 2},
      '2021': {displayName: 2021, name: 2021, version: 3},
    }
  },

  JW_CAD: {
    name: 'JW_CAD',
    displayName: 'Jw-CAD(******.jww)',
    children: {
      '0': {displayName: '7以前', name: 0, version: 0},
      '7': {displayName: 7, name: 7, version: 1},
      '8': {displayName: 8, name: 8, version: 2},
    }
  },

  DRA_CAD: {
    name: 'DRA_CAD',
    displayName: 'DRA-CAD(******.mpz)',
    children: {
      '0': {displayName: '16以前', name: 0, version: 0},
      '16': {displayName: 16, name: 16, version: 1},
      '17': {displayName: 17, name: 17, version: 2},
      '18': {displayName: 18, name: 18, version: 3},
    }
  },

  VECTOR_WORKS: {
    name: 'VECTOR_WORKS',
    displayName: 'Vectorworks（******.vwx）',
    children: {
      '0': {displayName: '2016以前', name: 0, version: 0},
      '2016': {displayName: 2016, name: 2016, version: 1},
      '2017': {displayName: 2017, name: 2017, version: 2},
      '2018': {displayName: 2018, name: 2018, version: 3},
      '2019': {displayName: 2019, name: 2019, version: 4},
      '2020': {displayName: 2020, name: 2020, version: 5},
      '2021': {displayName: 2021, name: 2021, version: 6},
    }
  },
};